import { AZ_QUERY_CONST, PB_QUERY_CONST } from '../../../constants';

const getAzQueryFilter = (query, name) => {
  if (!query || !name) return null;
  return query[`${PB_QUERY_CONST}[${name}]${AZ_QUERY_CONST}`];
};

export default getAzQueryFilter;
